import axios from 'axios';
axios.interceptors.request.use(config => {
  config.headers['Cache-Control'] = 'no-cache';
  config.headers['Pragma'] = 'no-cache';
  return config;
}, error => {
  return Promise.reject(error);
});
export default axios;